import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { IPaginationPayload } from '../../../interfaces/shared/IPaginationPayload';
import { tryToFetchClients } from '../../../store/brokers/partner/clients/clientsSlice';
import { useGetXeroAuthUrlQuery } from '../../../store/reservations/reservationsApi';
import { useGetXeroCredentialsQuery } from '../../../store/xero-integration/xeroApi';
import ClientDetailsModal from './modals/ClientDetailsModal';
import ClientsTable from './tables/ClientsTable';
import Input from '../../../shared/input';


const Clients = () => {
    const dispatch = useAppDispatch();
    const [showDetailsModal, setShowDetailsModal] = useState<{ show: boolean, data: any }>()
    const [rows, setRows] = useState<any>([]);
    const [search, setSearch] = useState<string>();
    const [paginationState, setPaginationState] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
    });
    const { data: authUrl } = useGetXeroAuthUrlQuery({});
    const paginationData = useAppSelector((state) => state.clients.clients?.data?.page);
    const rowsLoading = useAppSelector((state) => state.clients.clientsAreLoading);
    const state = useAppSelector((state) => state.clients);

    const onResetPaginationState = () => {
        setPaginationState({
            pageNumber: 1,
            pageSize: paginationState?.pageSize || 10,
        })
    }

    useEffect(() => {
        if (state.clients) {
            const rows =
                state.clients?.data?.elements && Array.isArray(state.clients?.data.elements)
                    ? state.clients?.data.elements.map((r: any) => ({ ...r, id: r._id }))
                    : [];
            setRows(rows);
        }
    }, [state.clients]);

    const onGettingData = async () => {
        try {
            const accessToken = localStorage.getItem("xeroAccessToken");
            if (accessToken) {
                let data: any = { ...paginationState }
                if (search) {
                    data = {
                        ...data || {},
                        filters: search
                    }
                }
                await dispatch(tryToFetchClients(data)).unwrap();
            } else {
                window.location.assign(authUrl.authUrl);
            }
        } catch (err) {
            // err
        }
    }

    useEffect(() => {
        onGettingData();
    }, [paginationState]);

    const onChangeSearchValue = (e: any) => {
        setSearch(e)
        onResetPaginationState()
    }

    const onClickDetailsModal = (data: any) => {
        setShowDetailsModal({
            show: true,
            data
        })
        document.body.style.overflow = 'hidden';
    }

    const onCloseModals = () => {
        setShowDetailsModal(undefined)
        document.body.style.overflow = 'auto';
    }

    return (
        <div>
            <div>
                <p className='page-title'>Clients</p>
            </div>
            <div className='my-5 relative'>
                <div>
                    <Input
                        placeholder={'Search for Clients'}
                        dataQa={'search'}
                        containerStyle='mb-0 pb-0 relative min-w-[400px]'
                        inputStyle={`mb-0 border-0 focus:outline-none`}
                        icon={'/assets/shared/search.svg'}
                        showValue={true}
                        inputValue={search}
                        inputUniqueName={'search'}
                        onChangeInput={onChangeSearchValue}
                        hideInputSpace={true}
                    />
                </div>
                <ClientsTable
                    rows={rows}
                    rowsLoading={rowsLoading}
                    paginationData={paginationData}
                    onSeeClientDetails={onClickDetailsModal}
                    setPaginationState={setPaginationState}
                />
            </div>
            {showDetailsModal?.show &&
                <ClientDetailsModal
                    openModal={showDetailsModal?.show}
                    data={showDetailsModal?.data}
                    handleCloseModal={onCloseModals}
                />
            }
        </div>
    )
}
export default Clients;